import React, { useState, useEffect } from 'react';

const DocumentPreview = ({ url, filename }) => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadDocument();
  }, [url]);

  const loadDocument = async () => {
    try {
      // For .docx files, in production use: import mammoth from 'mammoth';
      // const arrayBuffer = await fetch(url).then(r => r.arrayBuffer());
      // const result = await mammoth.convertToHtml({ arrayBuffer });
      // setContent(result.value);

      // Mock content for demo
      setContent(`
        <h1>Document Preview</h1>
        <p>This is a sample document content. In a real implementation, this would show the actual content of your Word document.</p>
        <h2>Features</h2>
        <ul>
          <li>Rich text formatting</li>
          <li>Tables and images</li>
          <li>Headers and footers</li>
        </ul>
        <p>The document would be parsed using mammoth.js library to convert DOCX to HTML.</p>
      `);
    } catch (err) {
      setError('Failed to load document: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="bg-white rounded-lg p-8 text-center min-h-96 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 rounded-lg p-8 text-center min-h-96 flex items-center justify-center">
        <div className="text-red-500">
          <p className="font-medium">Failed to load document</p>
          <p className="text-sm mt-2">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg overflow-hidden min-h-96">
      <div className="bg-gray-50 p-4 border-b">
        <p className="text-sm text-gray-600">Document Preview</p>
      </div>
      <div className="p-6 overflow-auto max-h-96">
        <div 
          className="prose prose-sm max-w-none"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </div>
  );
};

export default DocumentPreview;